/**
 * Les diagnostics iOS du mode `?demo` : deux défauts inventés, en mémoire,
 * à la forme de `GET /v1/console/diagnostics-ios`.
 */
import { ApiError } from './api.js';
import type {
  CadreDiagnosticIos,
  DefautIos,
  DiagnosticIos,
  FiltreDiagnosticsIos,
} from '../types.js';

const JOUR = 86_400_000;
const depuis = (jours: number): string => new Date(Date.now() - jours * JOUR).toISOString();

const cadre = (binaire: string, decalage: number, profondeur: number): CadreDiagnosticIos => ({
  binaire,
  uuid: '00000000-0000-4000-8000-000000000000',
  decalage,
  adresse: 4_295_000_000 + decalage,
  profondeur,
  echantillons: null,
});

const PILE = [
  cadre('Artosera', 482_116, 0),
  cadre('Artosera', 311_904, 1),
  cadre('SwiftUI', 7_120_448, 2),
  cadre('UIKitCore', 1_204_772, 3),
];

const DEFAUTS: DefautIos[] = [
  {
    empreinte: 'a1b2c3d4e5f60718',
    type: 'plantage',
    app: { version: '1.0', build: '42', testflight: true },
    plantage: {
      typeException: 6,
      codeException: 0,
      signal: 5,
      raisonFin: 'Namespace SIGNAL, Code 5 Trace/BPT trap: 5',
      nomException: null,
    },
    blocage: null,
    occurrences: 3,
    premierLe: depuis(4),
    dernierLe: depuis(1),
    appareils: ['iPad16,3', 'iPhone18,1'],
    systemes: ['iPadOS 26.0.1', 'iPhone OS 26.0.1'],
    haut: PILE.slice(0, 3),
  },
  {
    empreinte: '0f1e2d3c4b5a6978',
    type: 'blocage',
    app: { version: '1.0', build: '42', testflight: true },
    plantage: null,
    blocage: { dureeMs: 3_400 },
    occurrences: 1,
    premierLe: depuis(2),
    dernierLe: depuis(2),
    appareils: ['iPhone17,3'],
    systemes: ['iPhone OS 26.0'],
    haut: PILE.slice(1, 4),
  },
];

export const demoDiagnosticsIos = {
  lister(type: FiltreDiagnosticsIos): DefautIos[] {
    return DEFAUTS.filter((defaut) => type === 'tous' || defaut.type === type);
  },
  lire(empreinte: string): DiagnosticIos {
    const defaut = DEFAUTS.find((d) => d.empreinte === empreinte);
    if (!defaut) throw new ApiError(404, 'ressource.introuvable', 'Diagnostic introuvable.');
    return {
      empreinte: defaut.empreinte,
      type: defaut.type,
      app: defaut.app,
      plantage: defaut.plantage,
      blocage: defaut.blocage,
      survenuLe: defaut.dernierLe,
      recuLe: defaut.dernierLe,
      systeme: defaut.systemes[0] ?? '',
      appareil: defaut.appareils[0] ?? '',
      architecture: 'arm64e',
      fils: [{ attribue: true, cadres: PILE }],
    };
  },
};
